/**
 *  customer优惠券操作接口
 */
 import { axios } from '@/utils/request'

//  const subPath = '/cdb/customer/tourRecords'
const subPath = 'cdb/customer/coupons'

 export default {
  getAllCouponByCustomer,
 }
 
 // 分页查询
 function getAllCouponByCustomer (cdbCustomerCode, parameter) {
   return axios({
     url: `${subPath}/getAllCouponByCustomer/${cdbCustomerCode}`,
     method: 'get',
     params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
   })
 }
 